import { Avatar, Tooltip } from 'antd';
import { EntityImage } from '../Entities/EntityImage';

// How many people are drawn before the rest collapse into a "+N" count.
const MAX_SHOWN = 3;

/**
 * The picture for a channel. A context (or a relationship whose members are
 * not known yet) shows its own picture. A relationship shows `people` — the
 * club of people in it other than the viewer: one person is drawn alone,
 * several as a stacked avatar group with each name on hover and the "+N"
 * overflow opening a popover listing the rest.
 *
 * `onOpen(entityOrPerson)` makes the pictures shortcuts: a person's picture
 * opens that person, the entity's own picture opens the entity. Clicks do not
 * bubble, so the surrounding row keeps its own handler.
 */
export default function ChannelAvatar({ entity, people, size = 24, onOpen }) {
    const open = target => (onOpen ? (e => { e.stopPropagation(); onOpen(target); }) : undefined);
    const cursor = onOpen ? 'pointer' : undefined;

    if (!people || people.length <= 1) {
        const target = people?.[0] || entity;
        return (
            <span onClick={open(target)} style={{ display: 'inline-flex', flexShrink: 0, cursor }}>
                <EntityImage entity={target} size={size} />
            </span>
        );
    }
    return (
        <Avatar.Group size={size} max={{ count: MAX_SHOWN }} style={{ flexShrink: 0 }}>
            {people.map(p => (
                <Tooltip key={p.id} title={p.name}>
                    {/* The group draws a 1px ring around each picture; size the
                        picture to sit inside it rather than be clipped by it. */}
                    <Avatar size={size} src={<EntityImage entity={p} size={size - 2} />} onClick={open(p)} style={{ cursor }} />
                </Tooltip>
            ))}
        </Avatar.Group>
    );
}
